<template>
  <div id="app">
    <router-view :meta="meta" :config="config" :key="$route.path" />
  </div>
</template>
<script>
export default {
  data: () => ({
    meta: {
      active_functions:[],
      active_locations:[],
      active_industries:[],
      active_required_exp:[],
      active_types:[]
    },
    config: null
  }),
  created: function() {
    let that = this
    this.$http.get(this.API_PREFIX + '/api/job/_meta').then(function (response) {
      //that.locations = response.data.active_locations
      //that.functions = response.data.active_functions.slice(0,5)
      //console.log(response)
      that.meta = response.data
      //sort by pinyin of location
      that.meta.active_locations.sort(function(a, b) {
        return a.c_fullname.localeCompare(b.c_fullname, 'zh')
      })
      //console.log(that.meta.active_locations)
    }).catch(function (error) {
      console.log(error)
    });

    this.$http.get(this.API_PREFIX + '/api/acca/job/generic/config').then(function (response) {
      that.config = response.data
      
    }).catch(function (error) {
      console.log(error)
    });

    this.$http.get(this.API_PREFIX + '/suntory.json').then(function (response) {
      that.$root.params = response.data
    }).catch(function (error) {
      console.log(error)
    });

    //check my profile
    this.$http.get(this.API_PREFIX + '/api/my_profile').then(function (response) {
      let p = response.data.objects[0],
          rid = p.real_person_id
      if (rid) {
        that.$http.get(that.API_PREFIX + '/api/real_person/' + rid).then(function (response) {
          //console.log(response.data.default_profile)
          if (response.data.default_profile)
            that.$store.commit('myResume', response.data.default_profile)
        }).catch(function (error) {
        })
      }
      that.$store.commit('myProfile', p)
    }).catch(function (error) {
      console.log(error)
      if(error.response) {
        switch(error.response.status) {
          case 401:
            that.$store.state.user = null
            break
        }
      }
    });
  },
  mounted: function() {
    window.addEventListener('hashchange',()=>{
      var currentPath = window.location.hash.slice(1);
      if(this.$router.path !== currentPath){
        this.$router.push(currentPath);
      }
    },false);
  }
}
</script>